import Oboe from 'oboe/dist/oboe-browser';

import { getBootstrap } from '@client/app/bootstrap';

const { API } = getBootstrap();

/**
 * @typedef {{ username: string, status: 'sent', response: object }} PushSuccess
 * @typedef {{ username: string, status: 'error', message: string }} PushError
 * @typedef {PushSuccess | PushError} PushResult
 */

export const BizCardPusherService = {
  /**
   * Push business cards to the given email addresses.
   * Returns an Oboe stream — use `.node('{username}', cb)` or `.done(cb)` to consume results.
   *
   * @param {string[]} emails
   * @param {string} [subject]
   * @param {string} [body]
   * @returns {import('oboe').Oboe}
   */
  pushBizcards(emails, subject, body) {
    const { context, token } = getBootstrap();

    /** @type {Record<string, unknown>} */
    const payload = { emails, context };

    if (subject) payload.emailsubject = subject;
    if (body) payload.emailbody = body;

    return Oboe({
      method: 'POST',
      url: `${API}/rest/domain/execute/streampushbizcards`,
      body: payload,
      headers: {
        Authorization: `Bearer ${token}`
      },
      pattern: '{username}',
      useXDomain: true,
      withCredentials: true
    });
  }
};
